<template>
  <div class="search-container">
    <div class="search-header">
      <div class="container">
          
      </div>
    </div>

    <section class="course-list-wrapper">
      <v-container>
        <div class="text-center">
            <v-icon color="error" size="60">mdi-emoticon-sad-outline</v-icon>
            <h1 class="display-3 font-weight-bold error--text mb-5">OOPS!</h1>
            <v-card elevation="0" flat max-width="500" style="margin: 0 auto;">
                <p style="font-size: 18px;">Sorry, the content you are looking for is not found.</p>
                <v-btn class="btn big_blue_button py-4" :loading="loader" @click="$router.push('/'), loader=true">Go to Homepage</v-btn>
            </v-card>
        </div>
      </v-container>
    </section>

    <KeepLearning></KeepLearning>
  </div>
</template>

<script>
import KeepLearning from "@/components/KeepLearning/KeepLearning.vue";
export default {
  name: "NoContent",
  data() {
    return {
        loader: false
    };
  },
  components: {
      KeepLearning
  },
  created () {
  },
  methods: {
    
  },
  
  mounted () { 

  },
};
</script>

<style lang="scss">
/*Search Page*/
.v-list-item {
  min-height: auto;
  padding: 9px 15px;

  & + * {
    border-top: 1px solid rgba(#0ea1df, 0.1);
  }
}

.v-list-item__title {
  font-size: 14px;
}
.search-container {
  padding: 2.5rem 0 0;
}
.search-title {
  font-weight: 400;
  font-family: var(--font-poppins);
  font-size: 24px;
  line-height: 1.5;
  .search-count {
    font-weight: 600;
  }
  .search-result {
    font-family: var(--font-lora);
    color: var(--color-red);
    font-weight: 700;
  }
}

.search-filter {
  font-size: 14px;
  font-family: var(--font-poppins);
  font-weight: 400;
  .sort-filter {
    margin-left: 18px;
    font-weight: 500;
  }
}

/*Media Object Default CSS Rule*/
img,
iframe,
video {
  max-width: 100%;
}

/* Pagination CSS Rule */
.pagination {
  list-style: none;
  font-size: 18px;
  font-family: var(--font-poppins);

  li + li {
    margin-left: 8px;
  }
}
</style>